import PipelineStateIcon, {
  colorForJob,
} from "~/components/shared/PipelineStateIcon/PipelineStateIcon";
import { Job } from "~/components/build/Show/lib/types";
import classNames from "classnames";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { sortJobsByState } from "~/components/build/Show/lib/sortJobsByState";
import { useStepDependencies } from "~/components/build/Show/lib/useStepDependencies";

export function State({ job }: { job: Job }) {
  const { build } = useBuild();
  const { missingDependencies } = useStepDependencies(job.stepUuid);
  const jobWithDeps = { ...job, missingDependencies };

  return (
    <PipelineStateIcon
      job={jobWithDeps}
      className={classNames("block h-4 w-4", colorForJob(jobWithDeps, build))}
      style={{ width: undefined, height: undefined }}
    />
  );
}

export const sortByState = sortJobsByState;
